import { useQuery } from '@tanstack/react-query';

import fetchUserById from '../api/fetchUserById';

const useGetUserById = (userId, noCache = false) => useQuery({
  queryKey: ['getUserData', userId],
  queryFn: () => fetchUserById(userId),
  enabled: !!userId,
  staleTime: noCache ? 0 : 10 * 60 * 1000, // Cache data for 10 minutes
});

export default useGetUserById;
